import type { IBaseCampaignVersion } from '~/modules/campaign/types';
import type { DateTimeFilter } from '~/presentation/ui';

import {
  getVersionDateRangeTitle,
  getEndOfDayBy,
  getVersionDateDescription,
} from '~/presentation/ui';
import { dayjsTzToLocalTZ } from '~/utils/dayjs';
import { semverToNum } from '~/utils';

export const convertToDateTimeFilters = (versions: IBaseCampaignVersion[]): DateTimeFilter[] => {
  const dataVersions = [...versions].sort(
    (a, b) => semverToNum(b.version) - semverToNum(a.version),
  );

  return dataVersions
    .map((item) => {
      if (!item.startedAt) return false;

      const isCurrentVersion = !item.completedAt;
      const since = dayjsTzToLocalTZ(item.startedAt).valueOf();
      const until = isCurrentVersion
        ? dayjsTzToLocalTZ(getEndOfDayBy()).valueOf()
        : dayjsTzToLocalTZ(item.completedAt!).valueOf();

      const title = getVersionDateRangeTitle({ since, until, isShowNow: isCurrentVersion });
      const description = getVersionDateDescription({ since, until, isShowNow: isCurrentVersion });

      return {
        title,
        alias: `${item.version}`,
        since,
        until,
        isVersion: true,
        isCurrentVersion,
        description,
        versionId: item.id,
      };
    })
    .filter(Boolean) as DateTimeFilter[];
};
